import { render, staticRenderFns } from "./fawaterk-checkout.vue?vue&type=template&id=6d7aa8f2&scoped=true"
import script from "./fawaterk-checkout.vue?vue&type=script&lang=js"
export * from "./fawaterk-checkout.vue?vue&type=script&lang=js"
import style0 from "./fawaterk-checkout.vue?vue&type=style&index=0&id=6d7aa8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7aa8f2",
  null
  
)

export default component.exports